/* eslint-disable no-restricted-globals */
import React, { useState, useEffect, useRef, useMemo } from "react";
import styled, { css } from "styled-components";
import { useNavigate } from "react-router-dom";

import { theme } from "styles";
// components
import Text from "components/ui/Text";
import TextField from "components/ui/TextField";
import Button from "components/entrance/Button";
//assets
import LeftArrow from "assets/icons/left-arrow.svg";

const SignupTemplate = ({
  title,
  buttonText,
  buttonColor,
  border,
  buttonOnClick,
  infoTitle = false,
  infoText = false,
  inputLabel,
  inputValue,
  inputValueChange,
  inputIsAutoFocus = false,
  inputIsDisabled = false,
  onClickFooter,
  onClickBack,
}) => {
  const navigate = useNavigate();
  const pageRef = useRef();
  const [height, setHeight] = useState(window.innerHeight);
  const [focused, setFocused] = useState(false);
  const onFocus = () => setFocused(true);
  const onBlur = () => {
    setTimeout(() => {
      setFocused(false);
    }, 100);
  };

  useEffect(() => {
    window.visualViewport.addEventListener("resize", (e) => {
      const pageHeight = e.target.height;
      setHeight(pageHeight + scrollY);
    });
    return;
  }, []);

  useEffect(() => {
    return () => {
      setFocused(false);
    };
  }, []);

  const handleClickBack = () => {
    if (onClickBack) {
      onClickBack();
      return;
    }
    navigate(-1);
  };

  const handleClickFooter = () => {
    onClickFooter();
  };

  const isValidation = useMemo(() => {
    if (inputValue.length >= 12) {
      return true;
    }
    return false;
  }, [inputValue]);

  return (
    <Wrapper ref={pageRef} height={height}>
      <WrapperTop>
        <WrapperHeader>
          <div onClick={handleClickBack}>
            <img src={LeftArrow} alt="back" />
          </div>
        </WrapperHeader>
        <Text fontSize="24px" fontWeight="700" lineHeight="30px">
          {title}
        </Text>
        <WrapperInput>
          <TextField
            type="tel"
            label={inputLabel}
            value={inputValue}
            onChange={inputValueChange}
            disabled={inputIsDisabled}
            autoFocus={inputIsAutoFocus}
            maxLength="13"
            onFocus={onFocus}
            onBlur={onBlur}
          />
        </WrapperInput>
      </WrapperTop>

      <WrapperBtm>
        {buttonText && (
          <>
            <Text
              display="block"
              color="primary50"
              fontSize="16px"
              fontWeight="600"
              lineHeight="24px"
              css={css`
                margin-bottom: 4px;
              `}
            >
              {infoTitle}
            </Text>
            <Text color="gray80" fontSize="14px">
              {infoText}
            </Text>
            <Button
              background={buttonColor}
              border={border}
              onClick={buttonOnClick}
              css={css`
                color: ${buttonColor === "white"
                  ? theme.colors["gray80"]
                  : theme.colors["white"]};
              `}
            >
              {buttonText}
            </Button>
          </>
        )}
        {!buttonText && !focused && (
          <Button
            color={isValidation ? "white" : "disable"}
            background={isValidation ? "primary100" : "gray5"}
            onClick={isValidation ? handleClickFooter : () => {}}
          >
            다음
          </Button>
        )}
        {focused && (
          <Footerbox
            onClick={isValidation ? handleClickFooter : () => {}}
            background={isValidation ? "primary100" : "gray5"}
          >
            <Text
              color={isValidation ? "white" : "disable"}
              fontSize="18px"
              lineHeight="24px"
            >
              다음
            </Text>
          </Footerbox>
        )}
      </WrapperBtm>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  padding: 0 20px 42px;
  background: #fff;
  height: ${(props) => `${props.height}px`};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`;
const Footerbox = styled.div`
  position: absolute;
  bottom: 0;
  width: 100vw;
  height: 56px;
  margin-left: -20px;
  padding: 16px 24px;
  text-align: center;
  background: ${(props) => `${theme.colors[props.background]}`};
  z-index: 10;
`;

const WrapperTop = styled.div`
  white-space: pre;
`;

const WrapperHeader = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  div {
    padding: 4px 20px 4px 0;
  }
`;
const WrapperInput = styled.div`
  margin-top: 32px;
`;

const WrapperBtm = styled.div`
  button {
    margin-top: 24px;
  }
`;

export default SignupTemplate;
